import React, { PropsWithChildren } from "react";
import { AddressSection } from "./AddressSection";

export const DefaultAddressSection: React.FC<PropsWithChildren> = ({
  children,
}: PropsWithChildren) => {
  if (typeof children == "string") {
    return <AddressSection address={children} />;
  } else {
    return <>{children}</>;
  }
};
